/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgLocationStroke = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M12 19s6.5-5.41 6.5-9a6.5 6.5 0 1 0-13 0c0 3.59 6.5 9 6.5 9m0 2s8-6.582 8-11a8 8 0 1 0-16 0c0 4.418 8 11 8 11" clipRule="evenodd" /><path fill="currentColor" d="M14 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0" /></svg>;
export default SvgLocationStroke;